import React from 'react';
import { useTranslation } from 'react-i18next';
import { isJson } from 'lib/utils/WYSIWYGEditorHelper';
import { stateToHTML } from 'draft-js-export-html';
import { convertFromRaw } from 'draft-js';
import type { QuestionInputProps } from '../types/questionnaire';

/**
 * Shared media item component for questionnaires
 * Handles: media_item (read-only display of note and media)
 */
export const MediaItem: React.FC<Omit<
  QuestionInputProps,
  'value' | 'onChange'
>> = ({ question }) => {
  const { t } = useTranslation();

  return (
    <>
      {question.note &&
        (isJson(question.note) ? (
          <div
            style={{ marginBottom: 10 }}
            dangerouslySetInnerHTML={{
              __html: stateToHTML(convertFromRaw(JSON.parse(question.note))),
            }}
          />
        ) : (
          <div style={{ marginBottom: 10 }}>{question.note}</div>
        ))}
      {question.media && (
        <iframe
          style={{
            border: 'none',
            width: '100%',
            maxWidth: '600px',
            aspectRatio: '16 / 9',
          }}
          src={question.media}
          title={t('YouTube video player')}
        />
      )}
    </>
  );
};
